import React, { useState } from 'react';
import { generateUploadDropzone } from "@uploadthing/react";
import "@uploadthing/react/styles.css";

// When using separate backend, we must set the URL to the server's uploadthing route
const UploadDropzone = generateUploadDropzone({ url: `${process.env.REACT_APP_API_BASE || 'http://localhost:5000'}/api/uploadthing` });

export default function UnitImagesUploader({ value, onChange, unitId }) {
  const [uploading, setUploading] = useState(false);

  const images = Array.isArray(value) ? value : [];
  const remaining = Math.max(0, 20 - images.length);

  const handleComplete = (res) => {
    // res: UploadedFileResponse[] with { name, size, key, url }
    const now = Date.now();
    const newImages = (res || []).map((f, idx) => ({
      url: f.url,
      key: f.key,
      name: `unit-${unitId || 'new'}-${now}-${idx}-${(f.name || '').replace(/\s+/g, '-')}`,
      size: f.size,
      type: undefined
    }));
    const merged = [...images, ...newImages].slice(0, 20);
    onChange && onChange(merged);
    setUploading(false);
  };

  const handleRemove = (index) => {
    const next = images.filter((_, i) => i !== index);
    onChange && onChange(next);
  };

  return (
    <div className="space-y-2">
      <div className="text-sm text-gray-600">Unit Images ({images.length}/20)</div>
      <div className="grid grid-cols-3 gap-2">
        {images.map((img, idx) => (
          <div key={idx} className="relative group border rounded overflow-hidden">
            <img src={img.url} alt={img.name || `image-${idx}`} className="w-full h-24 object-cover" />
            <button
              type="button"
              onClick={() => handleRemove(idx)}
              className="absolute top-1 right-1 bg-white/80 hover:bg-white text-xs px-1 py-0.5 rounded shadow"
            >
              Remove
            </button>
          </div>
        ))}
      </div>

      {remaining > 0 && (
        <div className="border rounded">
          <UploadDropzone
            endpoint="unitImages"
            onUploadBegin={() => setUploading(true)}
            onUploadError={() => setUploading(false)}
            onClientUploadComplete={handleComplete}
            config={{ mode: 'auto' }}
            className="ut-unstyled"
          />
        </div>
      )}

      {uploading && <div className="text-xs text-gray-500">Uploading...</div>}
    </div>
  );
}


